// src/components/Navbar.js
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Navbar.css";
import olympeakLogo from "../assets/olympeak_logo_new.png";
import { Menu, ArrowLeft } from "lucide-react";

export default function Navbar({
  tab,
  hideAvatar = false, // (kept for compatibility)
  showBack = false,
  backTo = "/plan",
  title, // optional override
}) {
  const { t } = useTranslation();
  const nav = useNavigate();

  const tabLabel = (key) => {
    const k = String(key || "").toLowerCase();
    return t(`nav.tabs.${k}`, "");
  };

  const centerTitle = title ?? tabLabel(tab) ?? " ";

  return (
    <header className="navbar">
      {showBack ? (
        <button
          type="button"
          className="app-icon-btn"
          aria-label={t("nav.back")}
          title={t("nav.back")}
          onClick={() => nav(backTo)}
        >
          <ArrowLeft size={18} />
        </button>
      ) : (
        <Link className="brand" to="/" aria-label={t("nav.brandAria")}>
          <img src={olympeakLogo} alt={t("nav.brandAlt")} className="brand-logo" />
        </Link>
      )}

      <button className="navbar-tab navbar-tab--active" aria-current="page">
        {centerTitle}
      </button>

      <div className="right">
        {!hideAvatar && (
          <button
            type="button"
            className="app-icon-btn"
            aria-label={t("nav.openMenu")}
            title={t("nav.openMenu")}
            onClick={() => nav("/profile")}
          >
            <Menu size={18} />
          </button>
        )}
      </div>
    </header>
  );
}